import { useEffect, useRef } from "react";
import * as PIXI from "pixi.js";

import "./borders.css";

export default function Borders({
    image,
    color = 0x692704,
    alpha = 1,
    scale = 1
}) {
    const containerRef = useRef(null);

    useEffect(() => {
        let app;
        let destroyed = false;


        async function initPixi() {
            if (!containerRef.current || !image) return;

            const width = containerRef.current.clientWidth;
            const height = containerRef.current.clientHeight;

            app = new PIXI.Application();

            await app.init({
                width,
                height,
                backgroundAlpha: 0,
                antialias: true
            });

            if (destroyed || !containerRef.current) {
                app.destroy(true);
                return;
            }

            containerRef.current.innerHTML = "";
            containerRef.current.appendChild(app.canvas);

            const borderTexture = await PIXI.Assets.load(image);

            if (destroyed || !app.stage) return;

            const sprite = new PIXI.Sprite(borderTexture);

            // sprite.width = width;
            // sprite.height = height;
            const scaledWidth = width * scale;
            const scaledHeight = height * scale;

            sprite.width = scaledWidth;
            sprite.height = scaledHeight;

            sprite.anchor.set(0.5);
            sprite.position.set(width / 2, height / 2);

            sprite.tint = color;
            sprite.alpha = alpha;

            app.stage.addChild(sprite);
        }

        initPixi();

        return () => {
            destroyed = true;

            if (app) {
                app.destroy(true);
            }
        };
    }, [image, color, alpha, scale]);

    return (
        <div
            className="pixi-border"
            ref={containerRef}
        />
    );
}